import {
  List,
  Datagrid,
  TextField,
  EmailField,
  BooleanField,
  DateField,
  ChipField,
  FunctionField,
} from "react-admin";
import { Chip } from "@mui/material";

export const AuthUserList = () => (
  <List>
    <Datagrid rowClick="show">
      <TextField source="id" label="ID" />
      <EmailField source="email" label="Email" />
      <TextField source="name" label="Name" />
      <TextField source="did" label="DID" />
      <BooleanField source="emailVerified" label="Email Verified" />
      <FunctionField
        label="Roles"
        render={(record: any) => (
          <>
            {record.metadata?.roles?.map((role: string) => (
              <Chip key={role} label={role} size="small" sx={{ mr: 0.5 }} />
            ))}
          </>
        )}
      />
      <DateField source="createdAt" label="Created" showTime />
    </Datagrid>
  </List>
);
